import html from "./VideoInstructionStep.html"
import "./VideoInstructionStep.css"

var module = angular.module("ResearchKitApplicationModule");

module.directive("videoInstructionStep", ["ceUrl", "WebViewStepFrameUrl",
	function (ceUrl, WebViewStepFrameUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {

				function reloadFrame() {
					var webContent = '<div style="height: 100%; width: 100%; display: -webkit-flexbox; display: -ms-flexbox; display: -webkit-flex; display: flex; -webkit-flex-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center; justify-content: center;"><video style="max-width: 100%; max-height: 300px;" controls poster="{thumbnailURL}" src="{videoURL}">Your browser does not support the video tag.</video></div>';
					webContent = webContent.replace("{videoURL}", scope.stepManager.step.videoURL);
					if (scope.stepManager.step.image) {
						webContent = webContent.replace("{thumbnailURL}", scope.stepManager.step.image);
					}

					// IE prevents all methods of dynamically setting sandboxed iframe content except via message passing. 
					var iFrame = $(iElement).find("iframe");
					iFrame.off("load");
					iFrame.on("load", function () {
						this.contentWindow.postMessage({ name: "RKStudioStepContent", content: webContent }, WebViewStepFrameUrl);
					});
					iFrame.attr("src", WebViewStepFrameUrl);
				}

				scope.$watch("stepManager.step.videoURL", reloadFrame);
				scope.$watch("stepManager.step.image", reloadFrame);
				scope.$watch("stepManager", reloadFrame);
			}
		};
	}]
);